import React from "react";
import Icon from "@ant-design/icons";
import { IIconProps } from "typings/icons.types";

const InfoSvg = (props: IIconProps) => {
  const { width = 22, height = 22 } = props;
  return (
    <svg width={width} height={height} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11 20.1666C5.93723 20.1666 1.83331 16.0627 1.83331 10.9999C1.83331 5.93717 5.93723 1.83325 11 1.83325C16.0627 1.83325 20.1666 5.93717 20.1666 10.9999C20.1666
       16.0627 16.0627 20.1666 11 20.1666ZM11 18.3333C12.9449 18.3333 14.8102 17.5606 16.1854 16.1854C17.5607 14.8101 18.3333 12.9448 18.3333 10.9999C18.3333 9.055
        17.5607 7.18974 16.1854 5.81447C14.8102 4.4392 12.9449 3.66659 11 3.66659C9.05506 3.66659 7.1898 4.4392 5.81453 5.81447C4.43926 7.18974 3.66665 9.055 3.66665
         10.9999C3.66665 12.9448 4.43926 14.8101 5.81453 16.1854C7.1898 17.5606 9.05506 18.3333 11 18.3333ZM10.0833 7.33325C10.0833 6.82699 10.4937 6.41658
          11 6.41658C11.5062 6.41658 11.9166 6.82699 11.9166 7.33325C11.9166 7.83951 11.5062 8.24992 11 8.24992C10.4937 8.24992 10.0833 7.83951 10.0833 7.33325ZM10.0833
           10.9999C10.0833 10.4937 10.4937 10.0833 11 10.0833C11.5062 10.0833 11.9166 10.4937 11.9166 10.9999V14.6666C11.9166 15.1728 11.5062 15.5833 11 15.5833C10.4937
            15.5833 10.0833 15.1728 10.0833 14.6666V10.9999Z"
        fill="currentColor"
      />
    </svg>
  );
};

const Info = (props: IIconProps) => <Icon component={() => <InfoSvg {...props} />} {...props} />;

export default Info;
